import Utils from '../../utils/utils';

export default {
  name: 'utils',
  proto: {
    utils: Utils,
  },
  static: {
    utils: Utils,
  },
};



// WEBPACK FOOTER //
// ./node_modules/framework7/modules/utils/utils.js